<div class="w-full h-full">
    <app-map-header></app-map-header>
    <div class="flex w-full mt-2" style="height: calc(100vh - 11rem);">
        <span class="absolute dragger top-1/2 px-2 py-4 bg-white hover:bg-gray-300 cursor-pointer ease-in-out duration-300 rounded-tr-lg rounded-br-lg" [ngClass]="{'left-0': !sidebar, 'left-1/4': sidebar}" (click)="toggleSidebar()">
            <img *ngIf="!sidebar" src="/assets/images/png/arrow_right_1x.png" alt="">
            <img *ngIf="sidebar" src="/assets/images/png/arrow_left_2x.png" alt="">
        </span>
        <app-map-sidebar class="w-1/4 ease-in-out duration-300" [ngClass]="{'w-0': !sidebar, 'w-1/4': sidebar}" [isShown]="render_element" (mapview)="setMapView($event)"></app-map-sidebar>
        <app-map-main class="w-3/4 ease-in-out duration-300" [ngClass]="{'w-full': !sidebar, 'w-3/4': sidebar}" [mapView]="map_view"></app-map-main>
        
    </div>
</div>
